import { Grid, makeStyles, Typography } from "@material-ui/core";
import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(3),
  },
  greenBigText: {
    color: COLORS.green,
    fontSize: "1.5rem",
  },
}));

export const RevenueChanges = ({ year, trading, values }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container alignItems="center">
        <Grid item xs={2}>
          <Typography align="center" variant="h3">
            {year}
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            {trading
              ? "Reducing unrealized revenues by:"
              : "Increasing power assets revenues by:"}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography className={classes.greenBigText}>{values[0]} </Typography>
        </Grid>
      </Grid>

      <Grid container alignItems="center">
        <Grid item xs={2} />
        <Grid item xs={8}>
          <Typography>Adding power revenues:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography className={classes.greenBigText}>{values[1]}</Typography>
        </Grid>
      </Grid>
    </div>
  );
};
